/// <amd-module name="SuiteCommerce.Blog.DataProvider.Category.Collection"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("SuiteCommerce.Blog.DataProvider.Category.Collection", ["require", "exports", "Backbone", "SuiteCommerce.Blog.DataProvider.Category.Model"], function (require, exports, Backbone_1, DataProvider_Category_Model_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var CategoryCollection = /** @class */ (function (_super) {
        __extends(CategoryCollection, _super);
        function CategoryCollection() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.model = DataProvider_Category_Model_1.CategoryModel;
            return _this;
        }
        CategoryCollection.prototype.getCategoryById = function (id) {
            return this.find(function (category) {
                return category.id === id;
            });
        };
        CategoryCollection.prototype.getCategoryByURLComponent = function (urlComponent) {
            return this.find(function (category) {
                return category.urlComponent === urlComponent;
            });
        };
        return CategoryCollection;
    }(Backbone_1.Collection));
    exports.CategoryCollection = CategoryCollection;
});
